<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen persistent transition="dialog-bottom-transition" :overlay="false">

      <v-card>
        <v-toolbar dark color="secondary">
          <v-icon small>fas fa-lock</v-icon>
          <v-toolbar-title>Acceso</v-toolbar-title>
        </v-toolbar>

          <v-card-title primary-title>
            <h3 class="headline mb-0">Proporcione su usuario y contraseña</h3>
          </v-card-title>

          <v-card-text>
            <v-form v-model="valid" ref="form">
              <v-text-field prepend-icon="fas fa-user-circle"
                label="Usuario"
                v-model="credenciales.username"
                required
              ></v-text-field>
              <v-text-field prepend-icon="fas fa-key"
                label="Contraseña"
                v-model="credenciales.password"
                type="password"
                required
              ></v-text-field>
            </v-form>

          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" @click="doLogin(credenciales)">
              <v-icon small left>fas fa-sign-in-alt</v-icon>
              Ingresar
            </v-btn>
          </v-card-actions>

        <v-snackbar
          :timeout="3000"
          :color="'error'"
          v-model="snackbar"
        >
          <span>Usuario o Contraseña Incorrectos</span>
        </v-snackbar>
      </v-card>
    </v-dialog>
  </v-layout>

</template>

<script>
import login from '../services/login'
import Vue from 'vue'

export default {
  name: 'login',
  data () {
    return {
      valid : false,
      snackbar: false,
      credenciales: {
        username: '',
        password: ''
      },
      dialog : false
    }
  },
  methods: {
    async doLogin(credenciales) {
      let res = await login.doLogin(credenciales)
      console.log(res)
      if (res.data.ok) {
        await Vue.localForage.$setItem('token', res.data.token)
        await Vue.localForage.$setItem('user', res.data.user)
        this.$router.replace('Home')
      } else {
        this.showError()
      }
    },

    showError() {
      this.snackbar = true
    }
  },
  watch: {
    errors: function (val) {
      if (val[val.length - 1].response.status === 403) {
        this.snackbar = true
      }
    }
  },
  async mounted () {
    let logged = await login.checarSesion()
    if (logged.ok){
      this.$router.replace({ path: '/' })
    } else {
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue